<template>
  <div>
    <kst-output print-mode field="CashierID" :data="details" :catalog="Catalog"/>
    <kst-output print-mode field="WarehouseID" :data="details" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../SlrcCatalog.js";

export default {
  props: {
    details: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>